const apisConfig = {
  // backendURL: "http://192.168.1.11:8106",
  // fileURL: "http://192.168.1.11:8106/uploads/",
  backendURL: "https://www.crm-demo-server.com",
  fileURL:
    "https://functionext-demo-s3-crm-files.s3.ap-southeast-1.amazonaws.com/",
};

export default apisConfig;
